export const TRADE_IN_COMPONENT = 'tradeInComponent';
